<script setup lang="ts">
import { useRuntimeConfig } from '#app'
import { useUserData } from '~/composables/account/use-user-data'
import { useNews } from '~/composables/news/use-news'
import { useLogin } from '~/composables/account/use-login'
import { useMetaStore } from '~/stores/meta.store'
import { sideBarCategories } from '~/resources/news'

const { postDetail, getNewsPostData } = useNews()
getNewsPostData()
const { isLogged, showModalLogin } = useLogin()
const { currentUser } = useUserData()
const { resetMetaStore } = useMetaStore()
const environment = useRuntimeConfig().public

const lodeSlug = sideBarCategories[1].slug
const gptoken = currentUser?.value.gptoken
const loDeMobileUrl = environment.LODE_MOBILE_URL

const handleSubmit = (): void => {
  if (isLogged.value) {
    window.open(`${loDeMobileUrl}${gptoken}`, '_blank')
    return
  }
  showModalLogin()
}

onBeforeUnmount(resetMetaStore)
</script>
<template>
  <div class="news layout-no-pb">
    <div class="header header-mb d-flex just-between align-items-center">
      <div class="d-flex align-items-center">
        <NuxtLink to="/tin-tuc">
          <img src="~/assets/images/icons/ic-back-arrow.svg" alt="back arrow icon" width="24" height="24" />
        </NuxtLink>
      </div>
      <div class="header__name flex-grow-1">
        <span class="page-name">{{ postDetail?.categories[0]?.name }}</span>
      </div>
    </div>
    <div class="news-detail news-content">
      <h1 class="title-zone">{{ postDetail.title }}</h1>
      <div class="content-write" v-html="postDetail.content"></div>
      <div
        v-if="postDetail?.categories[0]?.slug === lodeSlug"
        class="news-detail-button button main main--primary"
        @click="handleSubmit"
      >
        Đánh lô ngay
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '~scssAsset/mobile/news/index.scss';
@import '~scssAsset/mobile/news/news-detail.scss';
@import '~scssAsset/mobile/layouts/header/index.scss';
</style>
